export const normalizeString = (str: string) => {
  return str
    .normalize('NFD')
    ?.replace(/\?(.*)/gm, '')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.replace(/,/g, '')
    ?.replace(/\s/g, '-')
    .toLowerCase()
}
